import React from 'react';
import { Skeleton } from '@cubeyou-team/hx-react-components';

const NotificationItemsLoader = () => {
  const speed = 1;
  return (
    <>
      <Skeleton speed={speed} width={390} height={100} viewBox="0 0 390 100">
        <circle cx="66" cy="30" r="20" />
        <rect x="98" y="14" rx="4" ry="4" width="200" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="280" height="8" />
        <rect x="98" y="50" rx="4" ry="4" width="120" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={390} height={100} viewBox="0 0 390 100">
        <circle cx="66" cy="30" r="20" />
        <rect x="98" y="14" rx="4" ry="4" width="200" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="280" height="8" />
        <rect x="98" y="50" rx="4" ry="4" width="120" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={390} height={100} viewBox="0 0 390 100">
        <circle cx="66" cy="30" r="20" />
        <rect x="98" y="14" rx="4" ry="4" width="200" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="280" height="8" />
        <rect x="98" y="50" rx="4" ry="4" width="120" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={390} height={100} viewBox="0 0 390 100">
        <circle cx="66" cy="30" r="20" />
        <rect x="98" y="14" rx="4" ry="4" width="200" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="280" height="8" />
        <rect x="98" y="50" rx="4" ry="4" width="120" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={390} height={100} viewBox="0 0 390 100">
        <circle cx="66" cy="30" r="20" />
        <rect x="98" y="14" rx="4" ry="4" width="200" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="280" height="8" />
        <rect x="98" y="50" rx="4" ry="4" width="120" height="8" />
      </Skeleton>
      <Skeleton speed={speed} width={390} height={100} viewBox="0 0 390 100">
        <circle cx="66" cy="30" r="20" />
        <rect x="98" y="14" rx="4" ry="4" width="200" height="16" />
        <rect x="98" y="37" rx="4" ry="4" width="280" height="8" />
        <rect x="98" y="50" rx="4" ry="4" width="120" height="8" />
      </Skeleton>
    </>
  );
};
export default NotificationItemsLoader;
